import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap'
import { Icon } from '../Component'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from '../../utils/Utils'
import { HOMEPAGE_URL } from '../../services/api-common'
import { useGlobalStoreData } from '../../store/globalStore'

const ErrorModal = ({ isOpen, toggleModalFail, title, message }) => {
  const { t } = useTranslation()
  const languageGSD = useGlobalStoreData.language()

  const getContactPage = () => {
    if (languageGSD === LANGUAGES.TURKISH) { return `${HOMEPAGE_URL + '/' + languageGSD}/iletisim` }
    return `${HOMEPAGE_URL + '/' + languageGSD}/contact`
  }

  return (
    <Modal isOpen={isOpen.keyCode === 27 ? false : isOpen} toggle={toggleModalFail}>
      <ModalBody className="modal-body-lg text-center">
        <div className="nk-modal">
          <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
          <h4
            className="nk-modal-title">{title}</h4>
          <div className="nk-modal-text">
            <p className="lead">
              {message}
            </p>
            <p className="text-soft"><a href={getContactPage()}>{t('please_contact_us')}</a></p>
          </div>
          <div className="nk-modal-action mt-5">
            <Button color="light" size="lg" className="btn-mw" onClick={() => { toggleModalFail(false) }}>
              {t('return')}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ErrorModal
